import { Outlet } from 'react-router-dom';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';
import { StickyMobileCTA } from './StickyMobileCTA';

export function RootLayout() {
  return (
    <>
      <a href="#main" className="skip-link">
        Liigu sisu juurde
      </a>
      <SiteHeader />
      <Outlet />
      <SiteFooter />
      <StickyMobileCTA />
    </>
  );
}
